var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/create-hash/md5.js
// module id = 121
// module chunks = 3